export const orderList = {
  print: {
    shippingInstruction: '出荷指示',
    deliverySlip: '個票',
    deliveryList: '一覧表',
    deliveryReceipt: '納品書',
  },
}
